import React, { useEffect, useRef, useState } from "react";
import { LocalizationProvider, DateCalendar, ArrowDropDownIcon } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, Dialog, DialogContent, InputAdornment, DialogActions } from "@mui/material";
import dayjs from "dayjs";
import CustomButton from "../../reusableComponents/CustomButton";
import { isEmpty } from "../../pages/utils/utils";
import "./index.css"

const MonthYearPicker = ({
  placeholder = "Select Month & Year",
  minDate,
  maxDate,
  disableFuture = false,
  value,
  onChange,
  disabled,
  showTextField = true,
  isOpen = false,
  setIsOpen,
  isClearDate,
  primaryButton,
  secondaryButton,
  style = {},
  inputStyle = {}
}) => {
  const [open, setOpen] = useState(isOpen);
  const dateDataRef = useRef();
  const [selectedDate, setSelectedDate] = useState(!isEmpty(value) ? null : null);

  const handleCustomDateChange = (newValue) => {
    setSelectedDate(newValue);
    dateDataRef.current = newValue
  };
  const setDateData = () => {
    if (dateDataRef.current) {
      onChange(dateDataRef.current.format("YYYY-MM"));
    }
  }

  const handleOnclear = () => {
    setSelectedDate(null)
  }

  const handleClose = (data) => {
    setOpen(data)
    if (setIsOpen) {
      setIsOpen(data)
    }
  }
  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {
        showTextField && (
          <>
            <div className="monthInputContainer" style={{
              ...style
            }} >

              <input
                className="monthInput"
                placeholder={placeholder}
                disabled={disabled}
                name="password"
                value={selectedDate ? selectedDate.format("MM/YYYY") : ""}
                readOnly
                style={{ ...inputStyle }}
                onClick={() => !disabled ? handleClose(true) : ""} />
              <ArrowDropDownIcon />
            </div>
          </>

        )
      }
      <Dialog open={open} onClose={() => handleClose(false)}>
        <DialogContent>
          <DateCalendar
            sx={{ height: 'auto' }}
            views={["year", "month"]}
            openTo="month"
            disableFuture={disableFuture}
            minDate={minDate ? dayjs(minDate) : undefined}
            maxDate={maxDate ? dayjs(maxDate) : undefined}
            value={selectedDate}
            onChange={handleCustomDateChange}
          />
        </DialogContent>
        <DialogActions>
          {isClearDate && <CustomButton
            variant={"outlined"}
            text={secondaryButton || "Clear"}
            type={"secondary"}
            size={"sm"}
            onClick={() => { onChange(); handleClose(false); handleOnclear(); }}
          ></CustomButton>}
          <CustomButton
            variant={"contained"}
            text={primaryButton || "Ok"}
            type={"secondary"}
            size={"sm"}
            onClick={() => { setDateData(); handleClose(false) }}
          ></CustomButton>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default MonthYearPicker;
export const convertMonthYearToMidISO = (monthYear) => {
  const [year, month] = monthYear.split("-");
  const midMoment = dayjs(`${year}-${month}-15`).hour(12).minute(0).second(0).millisecond(0);
  return midMoment.toISOString();
};